import { render } from "./HomePageFive.vue?vue&type=template&id=8985d9b4"
import script from "./HomePageFive.vue?vue&type=script&lang=js"
export * from "./HomePageFive.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__